import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../constants';
import Moment from 'moment';
import ReactPlayer from 'react-player'

export default class Opinion extends Component {

    constructor(props) {
        super(props);
      
        this.state = { 
            resource: [],
            response: [],
            error: [],
            key: 0,
            clave: this.props.clave,
            security: JSON.parse(localStorage.getItem('userBulletin'))
          }
      }

      componentDidMount() {

        var code = 'NOTI';
        var key = this.props.clave;
        var url = `${API_URL}BulletinResourceUX/${key}/${code}`; 
        axios.get(url).then(response => response.data)
        .then((data) => {
            data.result = data.result.filter(item => item.cRec_Id===8);
            this.setState({ resource: data.result });            
            document.getElementById('loaderSector').classList.add('loader--hide');
            document.getElementById('contentSector').removeAttribute("hidden");
        })
        .catch(error => {
        });
        
    }


    render() {
        return ( 
            <div>
                <ul id="boletin__header-title">
                    <li className="boletin__subtitle-name ">
                    <span className="boletin__subtitle-name--pl">OPINIÓN Y CASOS DE ESTUDIO</span>
                    </li>
                </ul>
                <div className="row opinions-row">
                {this.state.resource.map((resource, index) => (
                    <div className="col-sm-6" key={resource.nRecursoCodigo}>
                        <div className="menu__user">
                            <div className="opinion__author">
                            <div>
                                <img className="opinion__author-img" style={{width:"140px", height:"138px"}} src="/img/multimedia.png"/>
                                {/* <ReactPlayer url={resource.sEnlaceVideo} playing={true} controls={true} /> */}
                            </div>
                            <span>
                                <strong>{resource.sAutor}</strong>
                            </span> 
                            <br />
                            <span><em>{resource.sCargo}</em></span>
                            </div>
                            <div className="opinion__column">
                                <p className="opinion__date">{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</p>
                                <p className="opinion__text">
                                    {resource.sTituloRecurso}
                                </p>
                                <p className="opinion__more-info">
                                    <a>
                                        <Link to={'/' + this.props.clave + '/' + resource.nRecursoCodigo } className="new-opportunity__more-info-link">
                                            
                                        <span className="new-opportunity__more-info-arrow">
                                            <i className="fas fa-chevron-right"></i>
                                        </span>
                                            
                                        </Link>
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
                    {/* <div className="col-sm-6 opinion-audio__column">
                    <blockquote className="blockquote-opinion">
                        Es importante estar preparado a nivel estructural, a la
                        hora de expandir un negocio. Yo lo aprendí por las malas.
                    </blockquote>
                    <div className="opinion-audio-author">
                        <span><strong>Ana Paula Moreno</strong></span><br />
                        <span><em>CEO Total exports</em></span>
                        <p className="opinion-audio__more-info">
                        <span className="opinion-audio__more-info-arrow">
                            <i className="fas fa-play"></i>
                        </span>
                        </p>
                    </div>
                    </div> */}
                </div>
            </div>
        )
    }

}